export default "__VITE_ASSET__CNPGlrlQ__"